// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tJu5","col":"styles_col__465uy"};